/* eslint-disable no-useless-constructor */
import React from 'react';
import PropTypes from 'prop-types';

import { DatePickerField } from '../../../containers/Form';

function DatePicker({ filterDefinition, filters, updateFilterState, onClose }) {
  const getMyStateFromProps = () => {
    const { group } = filterDefinition;

    let myState;
    filters.forEach(e => {
      if (e.group === group) myState = e.state;
    });

    return myState;
  };

  const onChange = value => {
    const { group } = filterDefinition;
    // if (props.filterDefinition.max && parseInt(value, 10) > props.filterDefinition.max) {
    //   return;
    // }
    const event = {
      group,
      value: group,
      state: value,
    };
    updateFilterState(event);
    if (onClose) {
      onClose();
    }
  };

  const value = getMyStateFromProps();
  const datePickerProps = filterDefinition.datePickerProps || {};

  return (
    <div className="list-item">
      {/* <div className="label-selector"> */}
      {React.createElement(DatePickerField, {
        value,
        onChange,
        id: filterDefinition.group,
        ...datePickerProps,
      })}
      {/* </div> */}
    </div>
  );
}

DatePicker.propTypes = {
  filterDefinition: PropTypes.shape({
    group: PropTypes.string.isRequired,
    datePickerProps: PropTypes.object,
  }).isRequired,
  filters: PropTypes.array.isRequired,
  updateFilterState: PropTypes.func.isRequired,
  onClose: PropTypes.func,
};

export default DatePicker;
